module.exports = __webpack_public_path__ + "ea46c7668641234b1513c93883d4ad58.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-9.png
// module id = 2271
// module chunks = 0